export const defaultContextCacheSize = 1024 * 1024 * 32;